import { Link } from "react-router-dom";
import { ShieldCheck, Briefcase, Zap, Star } from "lucide-react";

export function CitizenCard({ city, compact = false }) {
  if (!city) return null;
  const items = [[Zap, `Level ${city.level}`, "citizen-level"], [Briefcase, city.job_label ? `${city.job_label}${city.job_grade ? ` · ${city.job_grade}` : ""}` : "Unemployed", "citizen-job"], [Star, `${(city.fame || 0).toLocaleString()} Fame`, "citizen-fame"]];
  return (
    <Link to="/virtucity" data-testid="profile-citizen-card"
      className={`block rounded-2xl border border-gold/30 bg-[radial-gradient(ellipse_at_top_left,rgba(212,175,55,.16),transparent_60%)] hover:border-gold/60 transition-colors ${compact ? "p-3 mt-3" : "p-4 mt-4"}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 text-[11px] font-bold tracking-[0.18em] text-gold"><ShieldCheck size={13} />VIRTUCITY CITIZEN</div>
        <div className="flex items-center gap-2 text-[11px]">
          {city.online && <span className="flex items-center gap-1 text-emerald-400"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />In the city</span>}
          <span className="font-semibold text-gold" data-testid="citizen-tier">{city.tier}</span>
        </div>
      </div>
      {city.character_name && <div className="font-display font-semibold mt-1.5" data-testid="citizen-character">{city.character_name}</div>}
      <div className="flex flex-wrap gap-2 mt-2">
        {items.map(([I, label, tid]) => <span key={tid} className="surface-2 rounded-full px-2.5 h-7 text-xs flex items-center gap-1.5" data-testid={tid}><I size={12} className="text-gold" />{label}</span>)}
      </div>
    </Link>
  );
}
